
<template>
  <div v-if="validationErrors.length > 0">
    <div class="row text-center mt-3">
      <div class="col-12">
        <span style="font-size: 16px; color: red">{{ $t('general.form_validation_message') }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, toRefs } from 'vue';

const props = defineProps({
  validationErrors: {
    type: Array,
    default: () => [],
  },
});

const { validationErrors }    = toRefs(props);
</script>

<style scoped>

</style>